import automations from './Automations.aspx.json';
import campaigns from './Campaigns.aspx.json';
import notifications from './Notifications.json';
import common from './Common.json';
import landingPages from './LandingPages.aspx.json';
import mms from './MmsCampaigns.aspx.json';
import sms from './SMSCampaigns.aspx.json';
import master from './Pulseem.master.json';
import appBar from './AppBar.json';
import report from './Reports.json';
import mainReport from './MainReport.aspx.json';
import dashboard from './Dashboard.json';
import smsReport from './SMSReport.json';
import emailStatus from './EmailStatus.json';
import emoji from './Emoji.json';
import payment from './payment.json';
import siteTracking from './SiteTracking.json';
import client from './Client.json';
import recipient from './Recipient.json';
import group from './group.json';
import mmsreport from './MMSReport.json';
import languages from './languages.json';
import settings from './Settings.json'
import whatsapp from './WhatsappCreator.json';
import whatsappCampaign from './WhatsappCampaign.json';
import whatsappManagement from './WhatsappManagement.json';
import whatsappReport from './WhatsappReport.json';
import whatsappChat from './WhatsappChat.json';
import integrations from './Integrations.json'
import WhatsappApiResponse from './WhatsappApiResponse.json'
import SignUp from './SignUp.json';
import FileUploads from './FileUploads.json';
import SimplyClub from './WhiteLabel/SimplyClub.json';
import affiliate from './Affiliate.json';
import SubAccount from './SubAccount.json'
import billing from './Billing.json';
import TermsOfUse from './TermsOfUse.json'
import WhatsappOnBoarding from './WhatsappOnBoarding.json'
import RemoveMyData from './RemoveMyData.json'
import PopupTriggers from './PopupTriggers.json'
import Popup from './Popup.json';
import AI from './AI.json';
import SubUsers from './SubUsers.json';
import DataSources from './DataSources.json';
import SendSearch from './SendSearch.json';
import ClalCenter from './ClalCenter.json';

export const pl = {
	PopupTriggers,
	automations,
	campaigns,
	notifications,
	common,
	landingPages,
	mms,
	sms,
	appBar,
	master,
	report,
	mainReport,
	dashboard,
	smsReport,
	emailStatus,
	emoji,
	payment,
	siteTracking,
	client,
	recipient,
	group,
	mmsreport,
	languages,
	settings,
	integrations,
	whatsapp,
	whatsappCampaign,
	whatsappManagement,
	whatsappReport,
	whatsappChat,
	WhatsappApiResponse,
	SignUp,
	FileUploads,
	SimplyClub,
	affiliate,
	SubAccount,
	billing,
	TermsOfUse,
	WhatsappOnBoarding,
	RemoveMyData,
	Popup,
	AI,
	SubUsers,
	DataSources,
	SendSearch,
	ClalCenter
};
